import { TranslocoService } from '@jsverse/transloco';
import { GameId } from './game-id';

export function gameIdToName(gameId: GameId, translocoService: TranslocoService): string {
  switch (gameId) {
    case GameId.Solitaire:
      return translocoService.translate('games.solitaire-name');
    case GameId.Blocks:
      return translocoService.translate('games.blocks-name');
    case GameId.Blackjack:
      return translocoService.translate('games.blackjack-name');
    default:
      console.error('gameIdToName: Unexpected game ID');
      return '';
  }
}
